import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-construction',
  templateUrl: './construction.component.html',
  styleUrls: ['./construction.component.scss']
})
export class ConstructionComponent implements OnInit {

  public title = 'Construção';
  public form: FormGroup;

  public administrator_phone: {phone: string, ddi: string, invalid: boolean} = {
    phone: '',
    ddi: '',
    invalid: false
  };

  public concierge_phone: {phone: string, ddi: string, invalid: boolean} = {
    phone: '',
    ddi: '',
    invalid: false
  };


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.constructionForm();
  }

  public constructionForm(): void {
    this.form = this.formBuilder.group({
      id: [null],
      construction_name: [null],
      administrator_name: [null],
      administrator_phone: [null],
      janitor_name: [null],
      doorman_name: [null],
      concierge_phone: [null],
      sale_pickup: [null],
      in_pool: [null]
    });
  }

}
